/*
 * Created Date: 29-01-2024, 2:59:18 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Tue Jan 30 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { workspaceClassRoomNavigationConfig } from '../ClassRoom/configs/navigation'
import WorkspaceNavigationConfig from './navigation'
import WorkspaceRouterConfig from './router'

const WorkspaceConfig = {
	navigation: [...workspaceClassRoomNavigationConfig, WorkspaceNavigationConfig],
	router: WorkspaceRouterConfig
}

export default WorkspaceConfig
